import { CustomTypography } from 'app/shared/components/generic-ui/Typography/Typography';
import { IPourEventCard } from 'types';
import { useStyles } from './PourEventCardSection.styles';
import { translations } from 'app/locales/i18n';
import { useTranslation } from 'react-i18next';
import { PourEventCard } from '../PourEventCard/PourEventCard';
import { CircularProgress } from 'app/shared/components/generic-ui/CircularProgress';
import { SectionSpoiler } from 'app/shared/components/generic-ui/SectionSpoiler';
import { useLocation } from 'react-router';
import { UpcomingDetailsModal } from 'app/pages/pourEventDetails/UpcomingDetailsModal/UpcomingDetailsModal';
import { useState } from 'react';

interface IPourEventCardSection {
  pourEventCards?: IPourEventCard[];
  isLoading: boolean;
  isUpcoming: boolean;
  handleSubHeaderClick: (isUpcoming: boolean) => void;
}

export const PourEventCardSection = ({
  pourEventCards,
  isLoading,
  isUpcoming,
  handleSubHeaderClick,
}: IPourEventCardSection) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const upcoming = searchParams.get('upcoming');
  const isUpcomingQuery = upcoming === 'true';
  const [pourEvent, setPourEvent] = useState<IPourEventCard | undefined>(
    undefined,
  );

  return (
    <>
      {isLoading ? (
        <div className={classes.progress}>
          <CircularProgress withLabel />
        </div>
      ) : (
        <SectionSpoiler
          withIcons={false}
          header={isUpcomingQuery ? undefined : ' '}
          subHeadersLeft
          subHeaders={
            !isUpcomingQuery
              ? [
                  {
                    inactive: isUpcoming,
                    value: t(translations.notificationEntityPage.current),
                    onClickHandler: () => handleSubHeaderClick(false),
                  },
                  {
                    inactive: !isUpcoming,
                    value: t(translations.notificationEntityPage.upcoming),
                    onClickHandler: () => handleSubHeaderClick(true),
                  },
                ]
              : undefined
          }
        >
          {pourEventCards?.length ? (
            <div className={classes.pourEvents}>
              {pourEventCards.map(pourEventCard => (
                <PourEventCard
                  key={pourEventCard.internalId}
                  pourEventCard={pourEventCard}
                  isUpcoming={isUpcoming}
                  setPourEvent={setPourEvent}
                />
              ))}
            </div>
          ) : (
            <div className={classes.empty}>
              <CustomTypography variant="header6" color="greyscale3">
                {t(
                  translations.projectEventsPage.thereAreCurrentlyNoPourEvents,
                )}
              </CustomTypography>
            </div>
          )}
          {isUpcoming && pourEvent && (
            <UpcomingDetailsModal
              isOpen={true}
              closeHandler={() => setPourEvent(undefined)}
              pourEventGID={pourEvent.internalId}
              header={
                pourEvent?.name
                  ? pourEvent.name
                  : `${pourEvent.externalId || '-'}/${pourEvent.name || '-'}`
              }
            />
          )}
        </SectionSpoiler>
      )}
    </>
  );
};
